import { Middleware } from 'redux';

export const actionLoggerMiddleware: Middleware<object> = () => {
    return function wrapDispatchToAddLogging(next) {
        return function dispatchAndLog(action) {
            console.info('Action', action);

            return next(action);
        };
    };
};
